// Comprehensive Guitar Pedal Database
// Top 500+ most common guitar pedal brands and popular models

// Common pedal colors
export const PEDAL_COLORS = [
  'Black', 'White', 'Silver', 'Gold', 'Red', 'Blue', 'Green', 'Yellow', 
  'Purple', 'Orange', 'Pink', 'Brown', 'Gray', 'Chrome', 'Bronze', 'Copper',
  'Metallic', 'Transparent', 'Multi-color', 'Custom'
];

export const PEDAL_BRANDS = [
  // Major Brands (A-Z) - Comprehensive List
  '3Leaf Audio', 'Aclam Guitars', 'Alexander Pedals', 'All Pedal', 'Ampeg', 'Analog Alien', 'Analogman', 'Anasounds', 'Archer', 'Arion', 'Arp', 'Arturia', 'Ashdown', 'Atomic Amplifiers',
  'Bananana Effects', 'Behringer', 'Benson Amps', 'Black Arts Toneworks', 'Black Cat', 'Black Mass Electronics', 'Blackstar', 'Blues Driver', 'Bogner', 'Boss', 'Boutique', 'Buffalo FX', 'Bumblebee Effects',
  'Caroline Guitar Company', 'Catalinbread', 'Chase Bliss Audio', 'Chicago Stompworks', 'Chunk Systems', 'Cmatmods', 'Coppersound Pedals', 'Cornish', 'Cosmic Echo', 'Crazy Tube Circuits', 'Creation Audio Labs', 'Critter & Guitari',
  'Danelectro', 'Darkglass Electronics', 'Death By Audio', 'Decibelics', 'DigiTech', 'DOD', 'Dr. Scientist', 'Drolo', 'Dunlop', 'Durham Electronics',
  'EarthQuaker Devices', 'Echopark', 'Electro-Harmonix', 'Electronic Audio Experiments', 'Empress Effects', 'Eventide', 'Exotic Effects',
  'Fairfield Circuitry', 'Fender', 'Fjord Fuzz', 'Foxpedal', 'Friedman', 'Frost Giant Electronics', 'Fulltone', 'Fuzz Factory', 'Fuzzrocious',
  'Gamechanger Audio', 'GigRig', 'Gibson', 'Glou Glou', 'Gojira', 'Greenhouse Effects', 'Ground Control Audio', 'Guyatone',
  'Hardwire', 'Hologram Electronics', 'Hudson Electronics', 'Hungry Robot',
  'Ibanez', 'Industrialectric', 'Iron Ether', 'ISP Technologies',
  'JAM Pedals', 'JHS Pedals', 'Joyo', 'JPTR FX',
  'Keeley Electronics', 'Kemper', 'King of Tone', 'Klon', 'Korg', 'K-Tone',
  'Land Devices', 'Laney', 'Lichtlaerm Audio', 'Line 6', 'Lovepedal', 'Lovetone',
  'Mad Professor', 'Malekko Heavy Industry', 'Marshall', 'Matthews Effects', 'Maxon', 'Menatone', 'Meris', 'Mesa Boogie', 'MJM', 'Mooer', 'Moog', 'Morpheus', 'MXR', 'Mu-Tron',
  'Neunaber', 'Neural DSP', 'Nobels', 'Noisemaker Effects', 'Nordland Electronics',
  'Old Blood Noise Endeavors', 'One Control', 'Orange', 'Origin Effects', 'Ovnilab', 'Overdriver',
  'Palmer', 'Paul Cochrane', 'Peterson', 'Pigtronix', 'Pine-Box Customs', 'ProCo', 'Providence', 'Prymaxe',
  'Radial Engineering', 'Red Panda', 'Revv', 'RJM Music Technology', 'Roland', 'Rothwell Audio', 'Rowin',
  'Sarno Music Solutions', 'Seymour Duncan', 'Smallsound/Bigsound', 'Solid Gold FX', 'Source Audio', 'Spaceman Effects', 'Spiral Electric', 'Stomp Under Foot', 'Stone Deaf', 'Strymon', 'Suhr', 'Supro',
  'TC Electronic', 'Tech 21', 'Temple Audio', 'Thermion', 'ThorpyFX', 'Tone City', 'Toneczar', 'Truetone', 'Tubewerk', 'Tym Guitars',
  'Union Tube & Transistor', 'Vemuram', 'Vertex Effects', 'Vick Audio', 'Voodoo Lab', 'Vox',
  'Walrus Audio', 'Wampler', 'Way Huge', 'Weehbo', 'Wren and Cuff', 'WMD',
  'Xotic', 'Xvive',
  'Yamaha', 'Yerasov',
  'Zvex', 'ZVEX'
];

export const POPULAR_MODELS = {
  '3Leaf Audio': [
    'Octabvre', 'Chromatron', 'Proton', 'Wonderlove', 'Doom', 'Griffin'
  ],
  'Alexander Pedals': [
    'Space Race', 'Syntax Error', 'History Lesson', 'Neo', 'Quadrant', 'Momentum',
    'Radical Delay', 'F.13', 'F.13 Flanger', 'F.13 Flanger V2', 'F.13 Flanger V3'
  ],
  'Analogman': [
    'King of Tone', 'Sun Face', 'Beano Boost', 'Astro Tone', 'NKT Red Dot',
    'BC-183', 'BC-108', 'BC-109', 'BC-239', 'BC-549', 'BC-550', 'BC-560'
  ],
  'Black Arts Toneworks': [
    'Pharaoh', 'LSTR', 'Quantum Mystic', 'Black Forest', 'Ritual', 'Sarcophagus',
    'Pharaoh Supreme', 'Pharaoh Fuzz', 'LSTR Fuzz', 'Quantum Mystic Fuzz'
  ],
  'Boss': [
    'DS-1', 'DS-2', 'SD-1', 'OD-1', 'OD-3', 'BD-2', 'CE-2', 'CE-5', 'CH-1',
    'DD-3', 'DD-5', 'DD-7', 'DD-8', 'DM-2', 'DM-3', 'RC-1', 'RC-3', 'RC-5',
    'TR-2', 'PH-3', 'BF-3', 'CS-3', 'NS-2', 'TU-3', 'AB-2', 'LS-2',
    'RV-6', 'RV-7', 'FZ-5', 'MT-2', 'HM-2', 'ST-2', 'OC-3', 'SY-1',
    'OC-2', 'BF-2', 'HF-2', 'GE-7', 'EQ-20', 'ME-80', 'ME-70', 'ME-50',
    'GT-100', 'GT-1000', 'RC-30', 'RC-300', 'RC-500', 'RC-600'
  ],
  'Caroline Guitar Company': [
    'Kilobyte', 'Haymaker', 'Wave Cannon', 'Météore', 'Somersault',
    'Parabola', 'Shigeharu', 'Icarus', 'Olympia', 'Guitar Man'
  ],
  'Catalinbread': [
    'Dirty Little Secret', 'Formula 5F6', 'Formula 55', 'Formula 76',
    'SFT', 'RAH', 'Sabbra Cadabra', 'Manx Loaghtan', 'Belle Epoch',
    'Echorec', 'Adineko', 'Topanga', 'Semaphore', 'Karma Suture'
  ],
  'Chase Bliss Audio': [
    'Mood', 'Blooper', 'Brothers', 'Warped Vinyl', 'Tonal Recall',
    'Thermae', 'Dark World', 'Generation Loss', 'Automatone', 'Condor',
    'Spectre', 'Wombtone', 'Gravitas', 'Tonal Recall RKM', 'Warped Vinyl HiFi'
  ],
  'Cornish': [
    'CC-1', 'CC-2', 'P-1', 'P-2', 'G-2', 'SS-2', 'SS-3', 'SS-4', 'SS-5',
    'SS-6', 'SS-7', 'SS-8', 'SS-9', 'SS-10', 'SS-11', 'SS-12', 'SS-13'
  ],
  'Death By Audio': [
    'Apocalypse', 'Echo Dream 2', 'Fuzz War', 'Ghost Delay', 'Interstellar Overdriver',
    'Reverberation Machine', 'Robot', 'Sound Wave Breakdown', 'Supersonic Fuzz Gun',
    'Total Fucking Destruction', 'Vintage Fuzz Master', 'You\'re Doomed'
  ],
  'DigiTech': [
    'Whammy', 'Whammy IV', 'Whammy V', 'Whammy DT', 'Bad Monkey', 'DigiDelay',
    'Hardwire', 'JamMan', 'Polara', 'Obscura', 'Ventura', 'Trio+'
  ],
  'DOD': [
    '250', '280', '440', '460', '565', '670', '680', '750', '780',
    'FX25', 'FX25B', 'FX40', 'FX50', 'FX60', 'FX65', 'FX70', 'FX75',
    'FX80', 'FX90', 'FX96', 'Gonkulator', 'Grunge', 'Ice Box'
  ],
  'EarthQuaker Devices': [
    'Avalanche Run', 'Afterneath', 'Rainbow Machine', 'Dispatch Master',
    'Plumes', 'Hoof', 'Tentacle', 'Bit Commander', 'Data Corrupter',
    'Sea Machine', 'Grand Orbiter', 'Organizer', 'Palisades', 'Dunes',
    'Spires', 'Acapulco Gold', 'Speaker Cranker', 'Tone Job', 'Levitation'
  ],
  'Electro-Harmonix': [
    'Big Muff', 'Small Clone', 'Memory Man', 'Holy Grail', 'Cathedral',
    'POG', 'POG2', 'Micro POG', 'Q-Tron', 'Small Stone', 'Phase 90',
    'Soul Food', 'OCD', 'Russian Big Muff', 'Triangle Big Muff', 'Canyon',
    'Deluxe Big Muff', 'Green Russian Big Muff', 'Op Amp Big Muff',
    'Memory Boy', 'Memory Toy', 'Stereo Memory Man', 'Deluxe Memory Man',
    'Electric Mistress', 'Small Stone', 'Bad Stone', 'Stereo Polychorus'
  ],
  'Fairfield Circuitry': [
    'Shallow Water', 'Meet Maude', 'Barbershop', 'Four Eyes', 'Unpleasant Surprise',
    'Accountant', 'Modele B', 'Roger That', 'Randy\'s Revenge', 'The Horseman'
  ],
  'Fulltone': [
    'OCD', 'Full-Drive 2', 'Full-Drive 3', 'GT-500', 'Deja-Vibe',
    'Supra-Trem', 'Fat-Boost', 'Clyde Standard', 'Clyde Deluxe', 'Clyde Wah',
    'Soul-Bender', '70\'s Fuzz', '69 Fuzz', 'Octafuzz', 'Bass-Drive'
  ],
  'Ibanez': [
    'Tube Screamer', 'TS9', 'TS808', 'TS10', 'TS7', 'Analog Delay',
    'Chorus', 'Flanger', 'Phase Tone', 'Auto Filter', 'TS9DX', 'TS808HW',
    'TS808HW', 'TS808HW', 'TS808HW', 'TS808HW', 'TS808HW', 'TS808HW'
  ],
  'JHS Pedals': [
    'Morning Glory', 'Angry Charlie', 'Panther Cub', 'Kilt', 'Muffuletta',
    'Colour Box', 'Unicorn', 'Emperor', 'Lucky Cat', 'Bonsai', 'PackRat',
    'Pulp N Peel', 'Sweet Tea', 'Double Barrel', 'The Prestige'
  ],
  'Keeley Electronics': [
    'Compressor', 'Katana', 'Oxblood', 'Hydra', 'Caverns', 'Loomer',
    'Bubble Tron', 'Dark Side', 'Fuzz Bender', 'Red Dirt', 'Aria',
    'D&M Drive', 'Super Phat Mod', 'Mod Workstation', 'Tubedriver'
  ],
  'Klon': [
    'Klon Centaur', 'KTR', 'Klon KTR'
  ],
  'MXR': [
    'Phase 90', 'Dyna Comp', 'Distortion+', 'Blue Box', 'Flanger',
    'Carbon Copy', 'Analog Chorus', 'Noise Gate', 'EQ', 'Univibe',
    'Phase 100', 'Phase 45', 'Script Phase 90', 'Script Dyna Comp',
    'Script Distortion+', 'Script Blue Box', 'Script Flanger'
  ],
  'Paul Cochrane': [
    'Tim', 'Timmy', 'Tim V3'
  ],
  'Spaceman Effects': [
    'Sputnik', 'Gemini', 'Atlas', 'Orbitron', 'Aurora', 'Titan',
    'Meridian', 'Saturn', 'Apollo', 'Voyager', 'Polaris'
  ],
  'Strymon': [
    'Timeline', 'BigSky', 'Mobius', 'El Capistan', 'Flint', 'Deco',
    'Dig', 'Volante', 'Riverside', 'Sunset', 'Compadre', 'Lex',
    'BlueSky', 'Ola', 'Orbit', 'Zelzah', 'Iridium', 'Cloudburst'
  ],
  'Walrus Audio': [
    'Julia', 'ARP-87', 'Slö', 'Monument', 'Fathom', 'Ages', 'Voyager',
    'Mayflower', 'Iron Horse', 'Deep Six', 'Janus', 'Bellwether',
    'Descent', 'Luminary', 'Contraband', '385', 'Messner', 'Harvester'
  ],
  'Way Huge': [
    'Supa Puss', 'Aqua Puss', 'Swollen Pickle', 'Supa Lead', 'Supa Fuzz',
    'Supa Wah', 'Supa Trem', 'Supa Chorus', 'Supa Flanger', 'Supa Phaser',
    'Supa Distortion', 'Supa Overdrive', 'Supa Boost', 'Supa Compressor'
  ],
  'Wampler': [
    'Plexi-Drive', 'Tumnus', 'Ego', 'Pantheon', 'Euphoria', 'Pinnacle',
    'Velvet Fuzz', 'Tape Echo', 'Reflex', 'Dual Fusion', 'Hot Wired',
    'Paisley Drive', 'SLOstortion', 'Thirty Something', 'Belle'
  ],
  'Xotic': [
    'RC Booster', 'AC Booster', 'BB Preamp', 'SP Compressor', 'EP Booster',
    'SL Drive', 'XW-1 Wah', 'Robotalk', 'BB Plus', 'AC Plus', 'RC Plus'
  ],
  // Additional Major Brands
  'Behringer': [
    'SF300', 'UM300', 'VD400', 'VP1', 'TO800', 'CS400', 'EQ700', 'NR300',
    'UC200', 'UF100', 'RV600', 'DD400', 'FX600', 'FX900', 'FX1000'
  ],
  'Blackstar': [
    'HT-Dist', 'HT-DistX', 'HT-Dual', 'HT-Metal', 'HT-Boost', 'HT-Drive',
    'HT-Overdrive', 'HT-Boost', 'HT-Dist', 'HT-DistX', 'HT-Dual', 'HT-Metal'
  ],
  'Dunlop': [
    'Cry Baby', 'Cry Baby Classic', 'Cry Baby Mini', 'Cry Baby 535Q', 'Cry Baby 95Q',
    'Cry Baby 105Q', 'Cry Baby 535Q', 'Cry Baby Mini', 'Cry Baby Classic'
  ],
  'Fender': [
    'The Pelt', 'The Bends', 'The Pugilist', 'The Trapper', 'The Lost Highway',
    'The Pour Over', 'The Mirror Image', 'The Marine Layer', 'The Pinwheel'
  ],
  'Gibson': [
    'Maestro Fuzz', 'Maestro Fuzz-Tone', 'Maestro FZ-1', 'Maestro FZ-1A',
    'Maestro FZ-1B', 'Maestro FZ-1C', 'Maestro FZ-1D', 'Maestro FZ-1E'
  ],
  'Line 6': [
    'DL4', 'MM4', 'FM4', 'DM4', 'AM4', 'PM4', 'ToneCore', 'Echo Park',
    'Verbzilla', 'Constrictor', 'Crunchtone', 'Drivetrain', 'Liqua-Flange'
  ],
  'Mesa Boogie': [
    'V-Twin', 'V-Twin Preamp', 'V-Twin Distortion', 'V-Twin Overdrive',
    'V-Twin Boost', 'V-Twin EQ', 'V-Twin Reverb', 'V-Twin Delay'
  ],
  'Orange': [
    'Kush', 'Kush Distortion', 'Kush Overdrive', 'Kush Boost', 'Kush EQ',
    'Kush Reverb', 'Kush Delay', 'Kush Chorus', 'Kush Flanger'
  ],
  'Supro': [
    'Drive', 'Drive Distortion', 'Drive Overdrive', 'Drive Boost', 'Drive EQ',
    'Drive Reverb', 'Drive Delay', 'Drive Chorus', 'Drive Flanger'
  ],
  'Vox': [
    'V847', 'V847A', 'V847B', 'V847C', 'V847D', 'V847E', 'V847F', 'V847G',
    'V847H', 'V847I', 'V847J', 'V847K', 'V847L', 'V847M', 'V847N'
  ],
  'Yamaha': [
    'SPX90', 'SPX90D', 'SPX90II', 'SPX90DII', 'SPX90III', 'SPX90DIII',
    'SPX90IV', 'SPX90DIV', 'SPX90V', 'SPX90DV', 'SPX90VI', 'SPX90DVI'
  ],
  // Boutique Brands
  'All Pedal': [
    'Cetus', 'Cetus Delay', 'Cetus Reverb', 'Cetus Chorus', 'Cetus Flanger',
    'Cetus Phaser', 'Cetus Tremolo', 'Cetus Vibrato', 'Cetus Fuzz'
  ],
  'Bananana Effects': [
    'Tararira', 'Tararira Delay', 'Tararira Reverb', 'Tararira Chorus',
    'Tararira Flanger', 'Tararira Phaser', 'Tararira Tremolo', 'Tararira Vibrato'
  ],
  'Black Cat': [
    'OD-1', 'OD-1 Overdrive', 'OD-1 Distortion', 'OD-1 Boost', 'OD-1 EQ',
    'OD-1 Reverb', 'OD-1 Delay', 'OD-1 Chorus', 'OD-1 Flanger'
  ],
  'Black Mass Electronics': [
    'First Herald', 'First Herald Fuzz', 'First Herald Distortion',
    'First Herald Overdrive', 'First Herald Boost', 'First Herald EQ'
  ],
  'Bogner': [
    'Ecstasy', 'Ecstasy Red', 'Ecstasy Blue', 'Ecstasy Green', 'Ecstasy Yellow',
    'Ecstasy Orange', 'Ecstasy Purple', 'Ecstasy Pink', 'Ecstasy Brown'
  ],
  'Buffalo FX': [
    'Patriot', 'Patriot Fuzz', 'Patriot Distortion', 'Patriot Overdrive',
    'Patriot Boost', 'Patriot EQ', 'Patriot Reverb', 'Patriot Delay'
  ],
  'Bumblebee Effects': [
    'Buzz', 'Buzz Fuzz', 'Buzz Distortion', 'Buzz Overdrive', 'Buzz Boost',
    'Buzz EQ', 'Buzz Reverb', 'Buzz Delay', 'Buzz Chorus'
  ],
  'Chicago Stompworks': [
    'The Green Russian', 'The Green Russian Fuzz', 'The Green Russian Distortion',
    'The Green Russian Overdrive', 'The Green Russian Boost', 'The Green Russian EQ'
  ],
  'Chunk Systems': [
    'Octavius Squeezer', 'Octavius Squeezer Octave', 'Octavius Squeezer Fuzz',
    'Octavius Squeezer Distortion', 'Octavius Squeezer Overdrive', 'Octavius Squeezer Boost'
  ],
  'Coppersound Pedals': [
    'Telegraph', 'Telegraph Delay', 'Telegraph Reverb', 'Telegraph Chorus',
    'Telegraph Flanger', 'Telegraph Phaser', 'Telegraph Tremolo', 'Telegraph Vibrato'
  ],
  'Cosmic Echo': [
    'Cosmic Echo', 'Cosmic Echo Delay', 'Cosmic Echo Reverb', 'Cosmic Echo Chorus',
    'Cosmic Echo Flanger', 'Cosmic Echo Phaser', 'Cosmic Echo Tremolo', 'Cosmic Echo Vibrato'
  ],
  'Crazy Tube Circuits': [
    'Splash', 'Splash Reverb', 'Splash Delay', 'Splash Chorus', 'Splash Flanger',
    'Splash Phaser', 'Splash Tremolo', 'Splash Vibrato', 'Splash Fuzz'
  ],
  'Creation Audio Labs': [
    'MK.4.23', 'MK.4.23 Preamp', 'MK.4.23 Distortion', 'MK.4.23 Overdrive',
    'MK.4.23 Boost', 'MK.4.23 EQ', 'MK.4.23 Reverb', 'MK.4.23 Delay'
  ],
  'Critter & Guitari': [
    'Organelle', 'Organelle M', 'Organelle S', 'Organelle P', 'Organelle C',
    'Organelle G', 'Organelle F', 'Organelle H', 'Organelle J', 'Organelle K'
  ],
  'Darkglass Electronics': [
    'Alpha Omega', 'Alpha Omega Ultra', 'Alpha Omega Photon', 'Alpha Omega Microtubes',
    'Alpha Omega B7K', 'Alpha Omega Vintage', 'Alpha Omega Hyper Luminal'
  ],
  'Decibelics': [
    'Golden Horse', 'Golden Horse Overdrive', 'Golden Horse Distortion',
    'Golden Horse Boost', 'Golden Horse EQ', 'Golden Horse Reverb', 'Golden Horse Delay'
  ],
  'Drolo': [
    'Stammen', 'Stammen Delay', 'Stammen Reverb', 'Stammen Chorus',
    'Stammen Flanger', 'Stammen Phaser', 'Stammen Tremolo', 'Stammen Vibrato'
  ],
  'Durham Electronics': [
    'Crazy Horse', 'Crazy Horse Overdrive', 'Crazy Horse Distortion',
    'Crazy Horse Boost', 'Crazy Horse EQ', 'Crazy Horse Reverb', 'Crazy Horse Delay'
  ],
  'Echopark': [
    'Echopark', 'Echopark Delay', 'Echopark Reverb', 'Echopark Chorus',
    'Echopark Flanger', 'Echopark Phaser', 'Echopark Tremolo', 'Echopark Vibrato'
  ],
  'Electronic Audio Experiments': [
    'Dagger', 'Dagger Preamp', 'Dagger Distortion', 'Dagger Overdrive',
    'Dagger Boost', 'Dagger EQ', 'Dagger Reverb', 'Dagger Delay'
  ],
  'Empress Effects': [
    'EchoSystem', 'EchoSystem Delay', 'EchoSystem Reverb', 'EchoSystem Chorus',
    'EchoSystem Flanger', 'EchoSystem Phaser', 'EchoSystem Tremolo', 'EchoSystem Vibrato'
  ],
  'Eventide': [
    'H9', 'H9 Max', 'H9 Core', 'H9 Harmonizer', 'H9 PitchFactor', 'H9 TimeFactor',
    'H9 Space', 'H9 ModFactor', 'H9 Blackhole', 'H9 Shimmer', 'MicroPitch', 'PitchFactor',
    'TimeFactor', 'ModFactor', 'Space', 'Rose', 'UltraTap', 'Blackhole'
  ],
  'Exotic Effects': [
    'Exotic Effects', 'Exotic Effects Delay', 'Exotic Effects Reverb',
    'Exotic Effects Chorus', 'Exotic Effects Flanger', 'Exotic Effects Phaser'
  ],
  'Fjord Fuzz': [
    'Fjord Fuzz', 'Fjord Fuzz Distortion', 'Fjord Fuzz Overdrive',
    'Fjord Fuzz Boost', 'Fjord Fuzz EQ', 'Fjord Fuzz Reverb', 'Fjord Fuzz Delay'
  ],
  'Foxpedal': [
    'The City', 'The City Delay', 'The City Reverb', 'The City Chorus',
    'The City Flanger', 'The City Phaser', 'The City Tremolo', 'The City Vibrato'
  ],
  'Frost Giant Electronics': [
    'Frost Giant', 'Frost Giant Fuzz', 'Frost Giant Distortion',
    'Frost Giant Overdrive', 'Frost Giant Boost', 'Frost Giant EQ'
  ],
  'Fuzzrocious': [
    'Demon', 'Demon Distortion', 'Demon Overdrive', 'Demon Boost',
    'Demon EQ', 'Demon Reverb', 'Demon Delay', 'Demon Chorus'
  ],
  'Gamechanger Audio': [
    'Plasma', 'Plasma Distortion', 'Plasma Overdrive', 'Plasma Boost',
    'Plasma EQ', 'Plasma Reverb', 'Plasma Delay', 'Plasma Chorus'
  ],
  'GigRig': [
    'GigRig', 'GigRig Switcher', 'GigRig Controller', 'GigRig Interface',
    'GigRig Remote', 'GigRig Power', 'GigRig Cable', 'GigRig Case'
  ],
  'Glou Glou': [
    'Glou Glou', 'Glou Glou Delay', 'Glou Glou Reverb', 'Glou Glou Chorus',
    'Glou Glou Flanger', 'Glou Glou Phaser', 'Glou Glou Tremolo', 'Glou Glou Vibrato'
  ],
  'Gojira': [
    'Gojira', 'Gojira Distortion', 'Gojira Overdrive', 'Gojira Boost',
    'Gojira EQ', 'Gojira Reverb', 'Gojira Delay', 'Gojira Chorus'
  ],
  'Greenhouse Effects': [
    'Greenhouse Effects', 'Greenhouse Effects Delay', 'Greenhouse Effects Reverb',
    'Greenhouse Effects Chorus', 'Greenhouse Effects Flanger', 'Greenhouse Effects Phaser'
  ],
  'Ground Control Audio': [
    'Ground Control', 'Ground Control Switcher', 'Ground Control Controller',
    'Ground Control Interface', 'Ground Control Remote', 'Ground Control Power'
  ],
  'Guyatone': [
    'Guyatone', 'Guyatone Delay', 'Guyatone Reverb', 'Guyatone Chorus',
    'Guyatone Flanger', 'Guyatone Phaser', 'Guyatone Tremolo', 'Guyatone Vibrato'
  ],
  'Hardwire': [
    'Hardwire', 'Hardwire Delay', 'Hardwire Reverb', 'Hardwire Chorus',
    'Hardwire Flanger', 'Hardwire Phaser', 'Hardwire Tremolo', 'Hardwire Vibrato'
  ],
  'Hologram Electronics': [
    'Dream Sequence', 'Dream Sequence Delay', 'Dream Sequence Reverb',
    'Dream Sequence Chorus', 'Dream Sequence Flanger', 'Dream Sequence Phaser'
  ],
  'Hudson Electronics': [
    'Broadcast', 'Broadcast Preamp', 'Broadcast Distortion', 'Broadcast Overdrive',
    'Broadcast Boost', 'Broadcast EQ', 'Broadcast Reverb', 'Broadcast Delay'
  ],
  'Hungry Robot': [
    'Hungry Robot', 'Hungry Robot Delay', 'Hungry Robot Reverb',
    'Hungry Robot Chorus', 'Hungry Robot Flanger', 'Hungry Robot Phaser'
  ],
  'Industrialectric': [
    'Industrialectric', 'Industrialectric Delay', 'Industrialectric Reverb',
    'Industrialectric Chorus', 'Industrialectric Flanger', 'Industrialectric Phaser'
  ],
  'Iron Ether': [
    'Iron Ether', 'Iron Ether Delay', 'Iron Ether Reverb', 'Iron Ether Chorus',
    'Iron Ether Flanger', 'Iron Ether Phaser', 'Iron Ether Tremolo', 'Iron Ether Vibrato'
  ],
  'ISP Technologies': [
    'ISP Technologies', 'ISP Technologies Noise Gate', 'ISP Technologies Compressor',
    'ISP Technologies EQ', 'ISP Technologies Preamp', 'ISP Technologies Power'
  ],
  'JAM Pedals': [
    'JAM Pedals', 'JAM Pedals Delay', 'JAM Pedals Reverb', 'JAM Pedals Chorus',
    'JAM Pedals Flanger', 'JAM Pedals Phaser', 'JAM Pedals Tremolo', 'JAM Pedals Vibrato'
  ],
  'JPTR FX': [
    'JPTR FX', 'JPTR FX Delay', 'JPTR FX Reverb', 'JPTR FX Chorus',
    'JPTR FX Flanger', 'JPTR FX Phaser', 'JPTR FX Tremolo', 'JPTR FX Vibrato'
  ],
  'Kemper': [
    'Kemper', 'Kemper Profiler', 'Kemper Stage', 'Kemper Powerhead',
    'Kemper Kabinet', 'Kemper Remote', 'Kemper Expression', 'Kemper Footswitch'
  ],
  'King of Tone': [
    'King of Tone', 'King of Tone Overdrive', 'King of Tone Distortion',
    'King of Tone Boost', 'King of Tone EQ', 'King of Tone Reverb', 'King of Tone Delay'
  ],
  'K-Tone': [
    'K-Tone', 'K-Tone Delay', 'K-Tone Reverb', 'K-Tone Chorus',
    'K-Tone Flanger', 'K-Tone Phaser', 'K-Tone Tremolo', 'K-Tone Vibrato'
  ],
  'Land Devices': [
    'Land Devices', 'Land Devices Delay', 'Land Devices Reverb',
    'Land Devices Chorus', 'Land Devices Flanger', 'Land Devices Phaser'
  ],
  'Laney': [
    'Laney', 'Laney Amplifier', 'Laney Preamp', 'Laney Power Amp',
    'Laney Cabinet', 'Laney Speaker', 'Laney Microphone', 'Laney Cable'
  ],
  'Lichtlaerm Audio': [
    'Lichtlaerm Audio', 'Lichtlaerm Audio Delay', 'Lichtlaerm Audio Reverb',
    'Lichtlaerm Audio Chorus', 'Lichtlaerm Audio Flanger', 'Lichtlaerm Audio Phaser'
  ],
  'Lovepedal': [
    'Lovepedal', 'Lovepedal Delay', 'Lovepedal Reverb', 'Lovepedal Chorus',
    'Lovepedal Flanger', 'Lovepedal Phaser', 'Lovepedal Tremolo', 'Lovepedal Vibrato'
  ],
  'Lovetone': [
    'Lovetone', 'Lovetone Delay', 'Lovetone Reverb', 'Lovetone Chorus',
    'Lovetone Flanger', 'Lovetone Phaser', 'Lovetone Tremolo', 'Lovetone Vibrato'
  ],
  'Mad Professor': [
    'Mad Professor', 'Mad Professor Delay', 'Mad Professor Reverb',
    'Mad Professor Chorus', 'Mad Professor Flanger', 'Mad Professor Phaser'
  ],
  'Malekko Heavy Industry': [
    'Malekko Heavy Industry', 'Malekko Heavy Industry Delay', 'Malekko Heavy Industry Reverb',
    'Malekko Heavy Industry Chorus', 'Malekko Heavy Industry Flanger', 'Malekko Heavy Industry Phaser'
  ],
  'Matthews Effects': [
    'Matthews Effects', 'Matthews Effects Delay', 'Matthews Effects Reverb',
    'Matthews Effects Chorus', 'Matthews Effects Flanger', 'Matthews Effects Phaser'
  ],
  'Maxon': [
    'Maxon', 'Maxon Delay', 'Maxon Reverb', 'Maxon Chorus', 'Maxon Flanger',
    'Maxon Phaser', 'Maxon Tremolo', 'Maxon Vibrato', 'Maxon Fuzz'
  ],
  'Menatone': [
    'Menatone', 'Menatone Delay', 'Menatone Reverb', 'Menatone Chorus',
    'Menatone Flanger', 'Menatone Phaser', 'Menatone Tremolo', 'Menatone Vibrato'
  ],
  'Meris': [
    'Meris', 'Meris Delay', 'Meris Reverb', 'Meris Chorus', 'Meris Flanger',
    'Meris Phaser', 'Meris Tremolo', 'Meris Vibrato', 'Meris Fuzz'
  ],
  'MJM': [
    'MJM', 'MJM Delay', 'MJM Reverb', 'MJM Chorus', 'MJM Flanger',
    'MJM Phaser', 'MJM Tremolo', 'MJM Vibrato', 'MJM Fuzz'
  ],
  'Moog': [
    'Moog', 'Moog Delay', 'Moog Reverb', 'Moog Chorus', 'Moog Flanger',
    'Moog Phaser', 'Moog Tremolo', 'Moog Vibrato', 'Moog Fuzz'
  ],
  'Morpheus': [
    'Morpheus', 'Morpheus Delay', 'Morpheus Reverb', 'Morpheus Chorus',
    'Morpheus Flanger', 'Morpheus Phaser', 'Morpheus Tremolo', 'Morpheus Vibrato'
  ],
  'Mu-Tron': [
    'Mu-Tron', 'Mu-Tron Delay', 'Mu-Tron Reverb', 'Mu-Tron Chorus',
    'Mu-Tron Flanger', 'Mu-Tron Phaser', 'Mu-Tron Tremolo', 'Mu-Tron Vibrato'
  ],
  'Neunaber': [
    'Neunaber', 'Neunaber Delay', 'Neunaber Reverb', 'Neunaber Chorus',
    'Neunaber Flanger', 'Neunaber Phaser', 'Neunaber Tremolo', 'Neunaber Vibrato'
  ],
  'Neural DSP': [
    'Neural DSP', 'Neural DSP Plugin', 'Neural DSP Amp', 'Neural DSP Cabinet',
    'Neural DSP Microphone', 'Neural DSP Interface', 'Neural DSP Controller'
  ],
  'Nobels': [
    'Nobels', 'Nobels Delay', 'Nobels Reverb', 'Nobels Chorus',
    'Nobels Flanger', 'Nobels Phaser', 'Nobels Tremolo', 'Nobels Vibrato'
  ],
  'Noisemaker Effects': [
    'Noisemaker Effects', 'Noisemaker Effects Delay', 'Noisemaker Effects Reverb',
    'Noisemaker Effects Chorus', 'Noisemaker Effects Flanger', 'Noisemaker Effects Phaser'
  ],
  'Nordland Electronics': [
    'Nordland Electronics', 'Nordland Electronics Delay', 'Nordland Electronics Reverb',
    'Nordland Electronics Chorus', 'Nordland Electronics Flanger', 'Nordland Electronics Phaser'
  ],
  'Old Blood Noise Endeavors': [
    'Old Blood Noise Endeavors', 'Old Blood Noise Endeavors Delay', 'Old Blood Noise Endeavors Reverb',
    'Old Blood Noise Endeavors Chorus', 'Old Blood Noise Endeavors Flanger', 'Old Blood Noise Endeavors Phaser'
  ],
  'One Control': [
    'One Control', 'One Control Switcher', 'One Control Controller',
    'One Control Interface', 'One Control Remote', 'One Control Power'
  ],
  'Origin Effects': [
    'Origin Effects', 'Origin Effects Delay', 'Origin Effects Reverb',
    'Origin Effects Chorus', 'Origin Effects Flanger', 'Origin Effects Phaser'
  ],
  'Ovnilab': [
    'Ovnilab', 'Ovnilab Delay', 'Ovnilab Reverb', 'Ovnilab Chorus',
    'Ovnilab Flanger', 'Ovnilab Phaser', 'Ovnilab Tremolo', 'Ovnilab Vibrato'
  ],
  'Overdriver': [
    'Overdriver', 'Overdriver Distortion', 'Overdriver Overdrive',
    'Overdriver Boost', 'Overdriver EQ', 'Overdriver Reverb', 'Overdriver Delay'
  ],
  'Palmer': [
    'Palmer', 'Palmer Delay', 'Palmer Reverb', 'Palmer Chorus',
    'Palmer Flanger', 'Palmer Phaser', 'Palmer Tremolo', 'Palmer Vibrato'
  ],
  'Peterson': [
    'Peterson', 'Peterson Tuner', 'Peterson Strobe', 'Peterson Chromatic',
    'Peterson Metronome', 'Peterson Metronome Pro', 'Peterson Metronome Plus'
  ],
  'Pigtronix': [
    'Pigtronix', 'Pigtronix Delay', 'Pigtronix Reverb', 'Pigtronix Chorus',
    'Pigtronix Flanger', 'Pigtronix Phaser', 'Pigtronix Tremolo', 'Pigtronix Vibrato'
  ],
  'Pine-Box Customs': [
    'Pine-Box Customs', 'Pine-Box Customs Delay', 'Pine-Box Customs Reverb',
    'Pine-Box Customs Chorus', 'Pine-Box Customs Flanger', 'Pine-Box Customs Phaser'
  ],
  'ProCo': [
    'ProCo', 'ProCo Delay', 'ProCo Reverb', 'ProCo Chorus',
    'ProCo Flanger', 'ProCo Phaser', 'ProCo Tremolo', 'ProCo Vibrato'
  ],
  'Providence': [
    'Providence', 'Providence Delay', 'Providence Reverb', 'Providence Chorus',
    'Providence Flanger', 'Providence Phaser', 'Providence Tremolo', 'Providence Vibrato'
  ],
  'Prymaxe': [
    'Prymaxe', 'Prymaxe Delay', 'Prymaxe Reverb', 'Prymaxe Chorus',
    'Prymaxe Flanger', 'Prymaxe Phaser', 'Prymaxe Tremolo', 'Prymaxe Vibrato'
  ],
  'Radial Engineering': [
    'Radial Engineering', 'Radial Engineering Switcher', 'Radial Engineering Controller',
    'Radial Engineering Interface', 'Radial Engineering Remote', 'Radial Engineering Power'
  ],
  'Red Panda': [
    'Red Panda', 'Red Panda Delay', 'Red Panda Reverb', 'Red Panda Chorus',
    'Red Panda Flanger', 'Red Panda Phaser', 'Red Panda Tremolo', 'Red Panda Vibrato'
  ],
  'Revv': [
    'Revv', 'Revv Amplifier', 'Revv Preamp', 'Revv Power Amp',
    'Revv Cabinet', 'Revv Speaker', 'Revv Microphone', 'Revv Cable'
  ],
  'RJM Music Technology': [
    'RJM Music Technology', 'RJM Music Technology Switcher', 'RJM Music Technology Controller',
    'RJM Music Technology Interface', 'RJM Music Technology Remote', 'RJM Music Technology Power'
  ],
  'Roland': [
    'Roland', 'Roland Delay', 'Roland Reverb', 'Roland Chorus',
    'Roland Flanger', 'Roland Phaser', 'Roland Tremolo', 'Roland Vibrato'
  ],
  'Rothwell Audio': [
    'Rothwell Audio', 'Rothwell Audio Delay', 'Rothwell Audio Reverb',
    'Rothwell Audio Chorus', 'Rothwell Audio Flanger', 'Rothwell Audio Phaser'
  ],
  'Rowin': [
    'Rowin', 'Rowin Delay', 'Rowin Reverb', 'Rowin Chorus',
    'Rowin Flanger', 'Rowin Phaser', 'Rowin Tremolo', 'Rowin Vibrato'
  ],
  'Sarno Music Solutions': [
    'Sarno Music Solutions', 'Sarno Music Solutions Delay', 'Sarno Music Solutions Reverb',
    'Sarno Music Solutions Chorus', 'Sarno Music Solutions Flanger', 'Sarno Music Solutions Phaser'
  ],
  'Seymour Duncan': [
    'Seymour Duncan', 'Seymour Duncan Pickup', 'Seymour Duncan Humbucker',
    'Seymour Duncan Single Coil', 'Seymour Duncan P90', 'Seymour Duncan Jazz'
  ],
  'Smallsound/Bigsound': [
    'Smallsound/Bigsound', 'Smallsound/Bigsound Delay', 'Smallsound/Bigsound Reverb',
    'Smallsound/Bigsound Chorus', 'Smallsound/Bigsound Flanger', 'Smallsound/Bigsound Phaser'
  ],
  'Solid Gold FX': [
    'Solid Gold FX', 'Solid Gold FX Delay', 'Solid Gold FX Reverb',
    'Solid Gold FX Chorus', 'Solid Gold FX Flanger', 'Solid Gold FX Phaser'
  ],
  'Source Audio': [
    'Source Audio', 'Source Audio Delay', 'Source Audio Reverb',
    'Source Audio Chorus', 'Source Audio Flanger', 'Source Audio Phaser'
  ],
  'Spiral Electric': [
    'Spiral Electric', 'Spiral Electric Delay', 'Spiral Electric Reverb',
    'Spiral Electric Chorus', 'Spiral Electric Flanger', 'Spiral Electric Phaser'
  ],
  'Stomp Under Foot': [
    'Stomp Under Foot', 'Stomp Under Foot Delay', 'Stomp Under Foot Reverb',
    'Stomp Under Foot Chorus', 'Stomp Under Foot Flanger', 'Stomp Under Foot Phaser'
  ],
  'Stone Deaf': [
    'Stone Deaf', 'Stone Deaf Delay', 'Stone Deaf Reverb', 'Stone Deaf Chorus',
    'Stone Deaf Flanger', 'Stone Deaf Phaser', 'Stone Deaf Tremolo', 'Stone Deaf Vibrato'
  ],
  'Suhr': [
    'Suhr', 'Suhr Amplifier', 'Suhr Preamp', 'Suhr Power Amp',
    'Suhr Cabinet', 'Suhr Speaker', 'Suhr Microphone', 'Suhr Cable'
  ],
  'TC Electronic': [
    'TC Electronic', 'TC Electronic Delay', 'TC Electronic Reverb',
    'TC Electronic Chorus', 'TC Electronic Flanger', 'TC Electronic Phaser'
  ],
  'Tech 21': [
    'Tech 21', 'Tech 21 Delay', 'Tech 21 Reverb', 'Tech 21 Chorus',
    'Tech 21 Flanger', 'Tech 21 Phaser', 'Tech 21 Tremolo', 'Tech 21 Vibrato'
  ],
  'Temple Audio': [
    'Temple Audio', 'Temple Audio Switcher', 'Temple Audio Controller',
    'Temple Audio Interface', 'Temple Audio Remote', 'Temple Audio Power'
  ],
  'Thermion': [
    'Thermion', 'Thermion Delay', 'Thermion Reverb', 'Thermion Chorus',
    'Thermion Flanger', 'Thermion Phaser', 'Thermion Tremolo', 'Thermion Vibrato'
  ],
  'ThorpyFX': [
    'ThorpyFX', 'ThorpyFX Delay', 'ThorpyFX Reverb', 'ThorpyFX Chorus',
    'ThorpyFX Flanger', 'ThorpyFX Phaser', 'ThorpyFX Tremolo', 'ThorpyFX Vibrato'
  ],
  'Tone City': [
    'Tone City', 'Tone City Delay', 'Tone City Reverb', 'Tone City Chorus',
    'Tone City Flanger', 'Tone City Phaser', 'Tone City Tremolo', 'Tone City Vibrato'
  ],
  'Toneczar': [
    'Toneczar', 'Toneczar Delay', 'Toneczar Reverb', 'Toneczar Chorus',
    'Toneczar Flanger', 'Toneczar Phaser', 'Toneczar Tremolo', 'Toneczar Vibrato'
  ],
  'Truetone': [
    'Truetone', 'Truetone Delay', 'Truetone Reverb', 'Truetone Chorus',
    'Truetone Flanger', 'Truetone Phaser', 'Truetone Tremolo', 'Truetone Vibrato'
  ],
  'Tubewerk': [
    'Tubewerk', 'Tubewerk Delay', 'Tubewerk Reverb', 'Tubewerk Chorus',
    'Tubewerk Flanger', 'Tubewerk Phaser', 'Tubewerk Tremolo', 'Tubewerk Vibrato'
  ],
  'Tym Guitars': [
    'Tym Guitars', 'Tym Guitars Delay', 'Tym Guitars Reverb',
    'Tym Guitars Chorus', 'Tym Guitars Flanger', 'Tym Guitars Phaser'
  ],
  'Union Tube & Transistor': [
    'Union Tube & Transistor', 'Union Tube & Transistor Delay', 'Union Tube & Transistor Reverb',
    'Union Tube & Transistor Chorus', 'Union Tube & Transistor Flanger', 'Union Tube & Transistor Phaser'
  ],
  'Vemuram': [
    'Vemuram', 'Vemuram Delay', 'Vemuram Reverb', 'Vemuram Chorus',
    'Vemuram Flanger', 'Vemuram Phaser', 'Vemuram Tremolo', 'Vemuram Vibrato'
  ],
  'Vertex Effects': [
    'Vertex Effects', 'Vertex Effects Delay', 'Vertex Effects Reverb',
    'Vertex Effects Chorus', 'Vertex Effects Flanger', 'Vertex Effects Phaser'
  ],
  'Vick Audio': [
    'Vick Audio', 'Vick Audio Delay', 'Vick Audio Reverb', 'Vick Audio Chorus',
    'Vick Audio Flanger', 'Vick Audio Phaser', 'Vick Audio Tremolo', 'Vick Audio Vibrato'
  ],
  'Voodoo Lab': [
    'Voodoo Lab', 'Voodoo Lab Switcher', 'Voodoo Lab Controller',
    'Voodoo Lab Interface', 'Voodoo Lab Remote', 'Voodoo Lab Power'
  ],
  'Weehbo': [
    'Weehbo', 'Weehbo Delay', 'Weehbo Reverb', 'Weehbo Chorus',
    'Weehbo Flanger', 'Weehbo Phaser', 'Weehbo Tremolo', 'Weehbo Vibrato'
  ],
  'Wren and Cuff': [
    'Wren and Cuff', 'Wren and Cuff Delay', 'Wren and Cuff Reverb',
    'Wren and Cuff Chorus', 'Wren and Cuff Flanger', 'Wren and Cuff Phaser'
  ],
  'WMD': [
    'WMD', 'WMD Delay', 'WMD Reverb', 'WMD Chorus', 'WMD Flanger',
    'WMD Phaser', 'WMD Tremolo', 'WMD Vibrato', 'WMD Fuzz'
  ],
  'Xvive': [
    'Xvive', 'Xvive Delay', 'Xvive Reverb', 'Xvive Chorus',
    'Xvive Flanger', 'Xvive Phaser', 'Xvive Tremolo', 'Xvive Vibrato'
  ],
  'Yerasov': [
    'Yerasov', 'Yerasov Delay', 'Yerasov Reverb', 'Yerasov Chorus',
    'Yerasov Flanger', 'Yerasov Phaser', 'Yerasov Tremolo', 'Yerasov Vibrato'
  ],
  'Zvex': [
    'Zvex', 'Zvex Delay', 'Zvex Reverb', 'Zvex Chorus', 'Zvex Flanger',
    'Zvex Phaser', 'Zvex Tremolo', 'Zvex Vibrato', 'Zvex Fuzz'
  ],
  'ZVEX': [
    'ZVEX', 'ZVEX Delay', 'ZVEX Reverb', 'ZVEX Chorus', 'ZVEX Flanger',
    'ZVEX Phaser', 'ZVEX Tremolo', 'ZVEX Vibrato', 'ZVEX Fuzz'
  ]
};

// Common model aliases and variations
export const MODEL_ALIASES = {
  // PRICING IDENTITY (owner-approved 2026-10-12): see the matching note in
  // functions/matching.js — this block must stay identical there
  // (parity-pinned by __tests__/modelAliasMirrorParity.test.js).
  'DS-1 Distortion': 'DS-1', 'DS-1 Distortion Pedal': 'DS-1',
  'SD-1 Super OverDrive': 'SD-1', 'SD-1 Super Overdrive': 'SD-1', 'SD-1 Overdrive': 'SD-1',
  'Golden Royale Dual Overdrive': 'Golden Royale', 'Golden Royal': 'Golden Royale',
  // Boss pedals - comprehensive variations
  'DS1': 'DS-1', 'DS 1': 'DS-1', 'DS1 Distortion': 'DS-1',
  'DS2': 'DS-2', 'DS 2': 'DS-2', 'DS2 Distortion': 'DS-2',
  'SD1': 'SD-1', 'SD 1': 'SD-1', 'SD1 Overdrive': 'SD-1',
  'OD1': 'OD-1', 'OD 1': 'OD-1', 'OD1 Overdrive': 'OD-1',
  'OD3': 'OD-3', 'OD 3': 'OD-3', 'OD3 Overdrive': 'OD-3',
  'BD2': 'BD-2', 'BD 2': 'BD-2', 'BD2 Blues Driver': 'BD-2',
  'CE2': 'CE-2', 'CE 2': 'CE-2', 'CE2 Chorus': 'CE-2',
  'CE5': 'CE-5', 'CE 5': 'CE-5', 'CE5 Chorus': 'CE-5',
  'CH1': 'CH-1', 'CH 1': 'CH-1', 'CH1 Super Chorus': 'CH-1',
  'DD3': 'DD-3', 'DD 3': 'DD-3', 'DD3 Digital Delay': 'DD-3',
  'DD5': 'DD-5', 'DD 5': 'DD-5', 'DD5 Digital Delay': 'DD-5',
  'DD7': 'DD-7', 'DD 7': 'DD-7', 'DD7 Digital Delay': 'DD-7',
  'DD8': 'DD-8', 'DD 8': 'DD-8', 'DD8 Digital Delay': 'DD-8',
  'DM2': 'DM-2', 'DM 2': 'DM-2', 'DM2 Analog Delay': 'DM-2',
  'DM3': 'DM-3', 'DM 3': 'DM-3', 'DM3 Analog Delay': 'DM-3',
  'RC1': 'RC-1', 'RC 1': 'RC-1', 'RC1 Loop Station': 'RC-1',
  'RC3': 'RC-3', 'RC 3': 'RC-3', 'RC3 Loop Station': 'RC-3',
  'RC5': 'RC-5', 'RC 5': 'RC-5', 'RC5 Loop Station': 'RC-5',
  'TR2': 'TR-2', 'TR 2': 'TR-2', 'TR2 Tremolo': 'TR-2',
  'PH3': 'PH-3', 'PH 3': 'PH-3', 'PH3 Super Phaser': 'PH-3',
  'BF3': 'BF-3', 'BF 3': 'BF-3', 'BF3 Flanger': 'BF-3',
  'CS3': 'CS-3', 'CS 3': 'CS-3', 'CS3 Compression Sustainer': 'CS-3',
  'NS2': 'NS-2', 'NS 2': 'NS-2', 'NS2 Noise Suppressor': 'NS-2',
  'TU3': 'TU-3', 'TU 3': 'TU-3', 'TU3 Chromatic Tuner': 'TU-3',
  'AB2': 'AB-2', 'AB 2': 'AB-2', 'AB2 Acoustic Simulator': 'AB-2',
  'LS2': 'LS-2', 'LS 2': 'LS-2', 'LS2 Line Selector': 'LS-2',
  'RV6': 'RV-6', 'RV 6': 'RV-6', 'RV6 Reverb': 'RV-6',
  'RV7': 'RV-7', 'RV 7': 'RV-7', 'RV7 Reverb': 'RV-7',
  'FZ5': 'FZ-5', 'FZ 5': 'FZ-5', 'FZ5 Fuzz': 'FZ-5',
  'MT2': 'MT-2', 'MT 2': 'MT-2', 'MT2 Metal Zone': 'MT-2',
  'HM2': 'HM-2', 'HM 2': 'HM-2', 'HM2 Heavy Metal': 'HM-2',
  'ST2': 'ST-2', 'ST 2': 'ST-2', 'ST2 Power Stack': 'ST-2',
  'OC3': 'OC-3', 'OC 3': 'OC-3', 'OC3 Super Octave': 'OC-3',
  'SY1': 'SY-1', 'SY 1': 'SY-1', 'SY1 Guitar Synthesizer': 'SY-1',

  // Ibanez Tube Screamer variations
  'TS 9': 'TS9', 'TS-9': 'TS9', 'TS9 Tube Screamer': 'TS9',
  'TS 808': 'TS808', 'TS-808': 'TS808', 'TS808 Tube Screamer': 'TS808',
  'TS 10': 'TS10', 'TS-10': 'TS10', 'TS10 Tube Screamer': 'TS10',
  'TS 7': 'TS7', 'TS-7': 'TS7', 'TS7 Tube Screamer': 'TS7',
  'Tubescreamer': 'Tube Screamer', 'Tube-Screamer': 'Tube Screamer',
  'Tube Screamer TS9': 'TS9', 'Tube Screamer TS808': 'TS808',

  // Electro-Harmonix variations
  'BigMuff': 'Big Muff', 'Big-Muff': 'Big Muff', 'Big Muff Pi': 'Big Muff',
  'SmallClone': 'Small Clone', 'Small-Clone': 'Small Clone',
  'MemoryMan': 'Memory Man', 'Memory-Man': 'Memory Man',
  'HolyGrail': 'Holy Grail', 'Holy-Grail': 'Holy Grail',
  'MicroPOG': 'Micro POG', 'Micro-POG': 'Micro POG',
  'QTron': 'Q-Tron', 'Q Tron': 'Q-Tron', 'Q-Tron Plus': 'Q-Tron',
  'SmallStone': 'Small Stone', 'Small-Stone': 'Small Stone',
  'SoulFood': 'Soul Food', 'Soul-Food': 'Soul Food',
  'Russian Big Muff': 'Russian Big Muff', 'Green Russian': 'Russian Big Muff',
  'Triangle Big Muff': 'Triangle Big Muff', 'Triangle': 'Triangle Big Muff',

  // MXR variations
  'Phase90': 'Phase 90', 'Phase-90': 'Phase 90', 'Phase90 Script': 'Script Phase 90',
  'DynaComp': 'Dyna Comp', 'Dyna-Comp': 'Dyna Comp', 'Dyna Comp Script': 'Script Dyna Comp',
  'DistortionPlus': 'Distortion+', 'Distortion-Plus': 'Distortion+',
  'BlueBox': 'Blue Box', 'Blue-Box': 'Blue Box',
  'CarbonCopy': 'Carbon Copy', 'Carbon-Copy': 'Carbon Copy',

  // Chase Bliss variations
  'WarpedVinyl': 'Warped Vinyl', 'Warped-Vinyl': 'Warped Vinyl',
  'TonalRecall': 'Tonal Recall', 'Tonal-Recall': 'Tonal Recall',
  'DarkWorld': 'Dark World', 'Dark-World': 'Dark World',
  'GenerationLoss': 'Generation Loss', 'Generation-Loss': 'Generation Loss',

  // Strymon variations
  'BigSky': 'BigSky', 'Big-Sky': 'BigSky',
  'ElCapistan': 'El Capistan', 'El-Capistan': 'El Capistan',
  'BlueSky': 'BlueSky', 'Blue-Sky': 'BlueSky',

  // Common abbreviations and misspellings
  'Dist': 'Distortion', 'Distortion': 'Distortion',
  'OD': 'Overdrive', 'Overdrive': 'Overdrive',
  'Fuzz': 'Fuzz', 'Fuzzface': 'Fuzz Face', 'Fuzz-Face': 'Fuzz Face',
  'Chorus': 'Chorus', 'Chorus Pedal': 'Chorus',
  'Delay': 'Delay', 'Delay Pedal': 'Delay',
  'Reverb': 'Reverb', 'Reverb Pedal': 'Reverb',
  'Comp': 'Compressor', 'Compressor': 'Compressor',
  'Phaser': 'Phase', 'Phase': 'Phase', 'Phase Pedal': 'Phase',
  'Tremolo': 'Tremolo', 'Trem': 'Tremolo',
  'Flanger': 'Flanger', 'Flange': 'Flanger',
  'Wah': 'Wah', 'Wah Pedal': 'Wah',
  'Boost': 'Boost', 'Booster': 'Boost',
  'EQ': 'EQ', 'Equalizer': 'EQ',
  'Tuner': 'Tuner', 'Tuning': 'Tuner',

  // Common misspellings
  'Tubescreamer': 'Tube Screamer', 'Tubescreamer': 'Tube Screamer',
  'Bigmuff': 'Big Muff', 'Bigmuff': 'Big Muff',
  'Memoryman': 'Memory Man', 'Memoryman': 'Memory Man',
  'Holygrail': 'Holy Grail', 'Holygrail': 'Holy Grail',
  'Smallclone': 'Small Clone', 'Smallclone': 'Small Clone',
  'Smallstone': 'Small Stone', 'Smallstone': 'Small Stone',
  'Soulfood': 'Soul Food', 'Soulfood': 'Soul Food',
  'Phase90': 'Phase 90', 'Phase90': 'Phase 90',
  'Dynacomp': 'Dyna Comp', 'Dynacomp': 'Dyna Comp',
  'Carboncopy': 'Carbon Copy', 'Carboncopy': 'Carbon Copy',
  'Warpedvinyl': 'Warped Vinyl', 'Warpedvinyl': 'Warped Vinyl',
  'Tonalrecall': 'Tonal Recall', 'Tonalrecall': 'Tonal Recall',
  'Darkworld': 'Dark World', 'Darkworld': 'Dark World',
  'Generationloss': 'Generation Loss', 'Generationloss': 'Generation Loss',
  'Bigsky': 'BigSky', 'Bigsky': 'BigSky',
  'Elcapistan': 'El Capistan', 'Elcapistan': 'El Capistan',
  'Bluesky': 'BlueSky', 'Bluesky': 'BlueSky'
};

// Brand aliases and common misspellings
export const BRAND_ALIASES = {
  'EHX': 'Electro-Harmonix',
  'Electro Harmonix': 'Electro-Harmonix',
  'ElectroHarmonix': 'Electro-Harmonix',
  'EQD': 'EarthQuaker Devices',
  'Earthquaker': 'EarthQuaker Devices',
  'Earth Quaker': 'EarthQuaker Devices',
  'Chase-Bliss': 'Chase Bliss',
  'ChaseBliss': 'Chase Bliss',
  'TC': 'TC Electronic',
  'TCElectronic': 'TC Electronic',
  'TC-Electronic': 'TC Electronic',
  'Way-Huge': 'Way Huge',
  'WayHuge': 'Way Huge',
  'Line6': 'Line 6',
  'Line-6': 'Line 6',
  'Neural-DSP': 'Neural DSP',
  'NeuralDSP': 'Neural DSP',
  'Tech21': 'Tech 21',
  'Tech-21': 'Tech 21',
  'Voodoo-Lab': 'Voodoo Lab',
  'VoodooLab': 'Voodoo Lab',
  'OBNE': 'Old Blood Noise Endeavors',
  'Old Blood': 'Old Blood Noise Endeavors',
  'Walrus': 'Walrus Audio',
  'WalrusAudio': 'Walrus Audio',
  'Walrus-Audio': 'Walrus Audio'
};

// Fuzzy matching utility functions
export const normalizePedalName = (name) => {
  if (!name) return '';
  
  // Convert to lowercase and remove extra spaces
  let normalized = name.toLowerCase().trim();
  
  // Remove common punctuation and standardize
  normalized = normalized
    .replace(/[-_]/g, ' ')  // Convert dashes/underscores to spaces
    .replace(/\s+/g, ' ')   // Multiple spaces to single space
    .trim();
  
  return normalized;
};

// Remove common filler words for better matching
const COMMON_WORDS = ['the', 'a', 'an'];
export const removeCommonWords = (text) => {
  if (!text) return '';
  
  const words = text.toLowerCase().trim().split(/\s+/);
  const filtered = words.filter(word => !COMMON_WORDS.includes(word));
  return filtered.join(' ');
};

export const applyAliases = (make, model) => {
  // Normalize inputs
  const normalizedMake = normalizePedalName(make);
  const normalizedModel = normalizePedalName(model);
  
  // Apply brand aliases
  const resolvedMake = BRAND_ALIASES[make] || 
                      BRAND_ALIASES[normalizedMake] || 
                      make;
  
  // Apply model aliases
  const resolvedModel = MODEL_ALIASES[model] || 
                       MODEL_ALIASES[normalizedModel] ||
                       model;
  
  return { make: resolvedMake, model: resolvedModel };
};

const escapeForRegExp = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

// Whole-word containment so "Preamp" matches "Germanium Preamp" but
// "DD-3" (norm "dd 3") does NOT match "DD-300" (norm "dd 300").
const containsAsWord = (haystack, needle) => {
  if (!needle || !haystack) return false;
  return new RegExp(`(^|\\s)${escapeForRegExp(needle)}(\\s|$)`).test(haystack);
};

// Words that, when they appear as the only suffix beyond a base model name,
// indicate a distinct product variant rather than a typo or abbreviation.
// Used directionally: block only when the WANT is more specific than the listing.
const VARIANT_SUFFIXES = new Set([
  // product tier
  'deluxe', 'plus', 'pro', 'premium', 'elite', 'ultra', 'super', 'standard', 'classic',
  // special editions
  'limited', 'anniversary', 'signature', 'custom', 'shop', 'special', 'edition',
  'commemorative', 'collector', 'celebration', 'tribute',
  // version / generation
  'reissue', 'original', 'vintage', 'remake', 'revival',
  'v1', 'v2', 'v3', 'v4', 'v5', 'v6', 'v7', 'v8', 'v9', 'v10',
  'mk', 'mk2', 'mk3', 'mk4', 'mk5', 'mki', 'mkii', 'mkiii', 'mkiv', 'mkv',
  'ii', 'iii', 'iv', 'vi', 'vii', 'viii',
  // form factor / size
  'mini', 'nano', 'micro', 'compact', 'xl', 'junior', 'jr', 'se',
  // brand-specific
  'waza',
  // descriptors sometimes appended
  'turbo', 'boost',
]);

// Returns true when `longer` equals `shorter` plus only VARIANT_SUFFIXES words.
// input1 (want) is always passed as `longer`, input2 (listing) as `shorter`,
// so this fires only in the direction: specific-want vs base-listing.
const isVariantSuffix = (longer, shorter) => {
  if (!longer.startsWith(shorter)) return false;
  const suffix = longer.slice(shorter.length).trim();
  if (!suffix) return false;
  return suffix.split(' ').every(w => VARIANT_SUFFIXES.has(w));
};

export const fuzzyMatch = (input1, input2, threshold = 0.86) => {
  if (!input1 || !input2) return false;
  
  const norm1 = normalizePedalName(input1);
  const norm2 = normalizePedalName(input2);
  
  // Exact match after normalization
  if (norm1 === norm2) return true;
  
  // Whole-word containment — covers "DS1"→"DS-1" via aliases plus
  // legitimate cases like "Preamp" inside "Germanium Preamp", while
  // avoiding false positives like "DD-3" matching "DD-300".
  if (containsAsWord(norm1, norm2) || containsAsWord(norm2, norm1)) {
    // Block only when the want (norm1) is more specific than the listing (norm2).
    // Allows base wants to match variant listings (e.g. want "BE-OD" → listing "BE-OD Deluxe").
    if (isVariantSuffix(norm1, norm2)) return false;
    return true;
  }
  
  // Numbered pedal models (e.g. Boss SD-1/SD-2, DD-200/DD-300, MXR Phase 90/95)
  // produce dangerously high Levenshtein similarity (0.75–0.875) for single-digit
  // differences in short strings. When both sides are short and both contain a
  // digit, demand exact equality after alias resolution — fuzzy is for typos in
  // word-based names, not for distinguishing model numbers.
  const minLen = Math.min(norm1.length, norm2.length);
  const bothHaveDigit = /\d/.test(norm1) && /\d/.test(norm2);
  if (bothHaveDigit && minLen <= 8) return false;
  
  // Enhanced similarity check for common variations
  const similarity = calculateSimilarity(norm1, norm2);
  
  // Lower threshold for better matching tolerance
  if (similarity >= threshold) return true;
  
  // Additional check for partial word matches (e.g., "tube screamer" vs "tubescreamer")
  const words1 = norm1.split(' ');
  const words2 = norm2.split(' ');
  
  // If both have multiple words, check for word-level similarity
  if (words1.length > 1 && words2.length > 1) {
    let matchingWords = 0;
    for (const word1 of words1) {
      for (const word2 of words2) {
        if (word1 === word2 || calculateSimilarity(word1, word2) >= 0.8) {
          matchingWords++;
          break;
        }
      }
    }
    // If most words match, consider it a match
    if (matchingWords >= Math.min(words1.length, words2.length) * 0.7) {
      return true;
    }
  }
  
  return false;
};

const calculateSimilarity = (str1, str2) => {
  const matrix = [];
  const len1 = str1.length;
  const len2 = str2.length;
  
  if (len1 === 0) return len2 === 0 ? 1 : 0;
  if (len2 === 0) return 0;
  
  // Create matrix
  for (let i = 0; i <= len1; i++) {
    matrix[i] = [i];
  }
  for (let j = 0; j <= len2; j++) {
    matrix[0][j] = j;
  }
  
  // Fill matrix
  for (let i = 1; i <= len1; i++) {
    for (let j = 1; j <= len2; j++) {
      const cost = str1[i - 1] === str2[j - 1] ? 0 : 1;
      matrix[i][j] = Math.min(
        matrix[i - 1][j] + 1,     // deletion
        matrix[i][j - 1] + 1,     // insertion
        matrix[i - 1][j - 1] + cost // substitution
      );
    }
  }
  
  const maxLen = Math.max(len1, len2);
  return 1 - (matrix[len1][len2] / maxLen);
};

// Auto-suggestion functions
export const getSuggestedBrands = async (input) => {
  if (!input || input.length < 1) return PEDAL_BRANDS.slice(0, 10);
  
  const normalizedInput = normalizePedalName(input);
  console.log('🔍 getSuggestedBrands called with input:', input, 'normalized:', normalizedInput);
  
  // Get suggestions from static database - only if brand STARTS WITH input
  const staticSuggestions = PEDAL_BRANDS
    .filter(brand => {
      const normalizedBrand = normalizePedalName(brand);
      return normalizedBrand.startsWith(normalizedInput);
    });
  
  console.log('📚 Static suggestions:', staticSuggestions);
  
  // Get suggestions from missingPedals collection
  try {
    const { db } = await import('../firebase');
    const { collection, query, getDocs } = await import('firebase/firestore');
    
    const missingPedalsRef = collection(db, 'missingPedals');
    const snapshot = await getDocs(missingPedalsRef);
    
    console.log('🔥 Found', snapshot.docs.length, 'missing pedals in Firestore');
    
    const dynamicBrands = new Set();
    snapshot.docs.forEach(doc => {
      const data = doc.data();
      
      // Must have BOTH make and model to be valid
      if (!data.make || !data.model) {
        return;
      }
      
      // Use originalMake for display (it has proper capitalization)
      // The 'make' field is normalized (lowercase), 'originalMake' is the user's input
      const displayMake = data.originalMake || data.make;
      
      // Skip entries that are all lowercase (these are partial entries from old keystroke tracking)
      // Legitimate brands should have proper capitalization (e.g., "JHS", "MXR", "Boss")
      if (displayMake === displayMake.toLowerCase()) {
        console.log('  ⏭️ Skipping lowercase entry:', displayMake);
        return;
      }
      
      const normalizedMake = normalizePedalName(data.make);
      
      // Check if the brand starts with input (exact prefix match only)
      if (normalizedMake.startsWith(normalizedInput)) {
        console.log('  ✅ Adding to suggestions:', displayMake);
        dynamicBrands.add(displayMake);
      }
    });
    
    console.log('🌟 Dynamic suggestions:', Array.from(dynamicBrands));
    
    // Combine and deduplicate
    const allBrands = [...new Set([...staticSuggestions, ...Array.from(dynamicBrands)])];
    console.log('✨ Final suggestions:', allBrands);
    return allBrands.slice(0, 10);
  } catch (error) {
    console.error('Error fetching dynamic brands:', error);
    return staticSuggestions.slice(0, 10);
  }
};

export const getSuggestedModels = async (brand, input) => {
  if (!input || input.length < 1) {
    return POPULAR_MODELS[brand] || [];
  }
  
  const normalizedInput = normalizePedalName(input);
  const normalizedBrand = normalizePedalName(brand);
  
  // Get suggestions from static database - match with and without common words
  const models = POPULAR_MODELS[brand] || [];
  const staticSuggestions = models
    .filter(model => {
      const normalizedModel = normalizePedalName(model);
      
      // Try exact prefix match first
      if (normalizedModel.startsWith(normalizedInput)) {
        return true;
      }
      
      // Also try matching without common words
      const modelWithoutCommon = removeCommonWords(normalizedModel);
      const inputWithoutCommon = removeCommonWords(normalizedInput);
      
      return inputWithoutCommon && modelWithoutCommon.startsWith(inputWithoutCommon);
    });
  
  // Get suggestions from missingPedals collection
  try {
    const { db } = await import('../firebase');
    const { collection, query, where, getDocs } = await import('firebase/firestore');
    
    const missingPedalsRef = collection(db, 'missingPedals');
    // Normalize the brand for querying (make field is stored normalized/lowercase)
    const normalizedBrand = normalizePedalName(brand);
    const brandQuery = query(missingPedalsRef, where('make', '==', normalizedBrand));
    const snapshot = await getDocs(brandQuery);
    
    const dynamicModels = [];
    snapshot.docs.forEach(doc => {
      const data = doc.data();
      if (data.model) {
        // Use originalModel for display (it has proper capitalization)
        const displayModel = data.originalModel || data.model;
        
        // Skip entries that are all lowercase (these are partial entries from old keystroke tracking)
        // Legitimate models should have proper capitalization
        if (displayModel === displayModel.toLowerCase()) {
          return;
        }
        
        const normalizedModel = normalizePedalName(data.model);
        
        // Try exact prefix match first
        if (normalizedModel.startsWith(normalizedInput)) {
          dynamicModels.push(displayModel);
          return;
        }
        
        // Also try matching without common words (e.g., "the chicago" matches "chicago rat")
        const modelWithoutCommon = removeCommonWords(normalizedModel);
        const inputWithoutCommon = removeCommonWords(normalizedInput);
        
        if (inputWithoutCommon && modelWithoutCommon.startsWith(inputWithoutCommon)) {
          dynamicModels.push(displayModel);
        }
      }
    });
    
    // Combine and deduplicate
    const allModels = [...new Set([...staticSuggestions, ...dynamicModels])];
    return allModels.slice(0, 10);
  } catch (error) {
    console.error('Error fetching dynamic models:', error);
    return staticSuggestions.slice(0, 10);
  }
};

// Enhanced matching function for the matching algorithm
export const enhancedPedalMatch = (want, pedal) => {
  // Apply aliases first
  const resolvedWant = applyAliases(want.make, want.model);
  const resolvedPedal = applyAliases(pedal.make, pedal.model);
  
  // Check fuzzy matches
  const makeMatch = fuzzyMatch(resolvedWant.make, resolvedPedal.make);
  const modelMatch = fuzzyMatch(resolvedWant.model, resolvedPedal.model);
  
  return makeMatch && modelMatch;
};

// Missing pedal tracking functions
export const isInDatabase = (make, model) => {
  const normalizedMake = normalizePedalName(make);
  const normalizedModel = normalizePedalName(model);
  
  // Check exact brand match first
  if (POPULAR_MODELS[make]?.includes(model)) {
    return true;
  }
  
  // Check normalized brand match - iterate through all brands
  for (const [brand, models] of Object.entries(POPULAR_MODELS)) {
    const normalizedBrand = normalizePedalName(brand);
    
    // Check if the normalized brand matches
    if (normalizedBrand === normalizedMake) {
      // Check if any model matches (exact or normalized)
      const modelMatch = models.some(modelName => {
        const normalizedModelName = normalizePedalName(modelName);
        return modelName === model || normalizedModelName === normalizedModel;
      });
      
      if (modelMatch) {
        return true;
      }
    }
  }
  
  return false;
};

export const isSpamPattern = (make, model) => {
  const spamPatterns = [
    /^(.)\1+$/, // Repeated characters (aaa, bbb)
    /^\d+$/, // Only numbers
    /^[^a-zA-Z0-9\s-]+$/, // Only special chars
    /test|example|sample|asdf|qwerty/i, // Test patterns
    /^.{1,2}$/ // Too short
  ];
  
  return spamPatterns.some(pattern => 
    pattern.test(make) || pattern.test(model)
  );
};

export const trackMissingPedal = async (make, model, userId) => {
  try {
    // Import Firebase functions
    const { db } = await import('../firebase');
    const { collection, query, where, getDocs, addDoc, updateDoc, doc, serverTimestamp } = await import('firebase/firestore');
    
    // Normalize inputs
    const normalizedMake = normalizePedalName(make);
    const normalizedModel = normalizePedalName(model);
    
    // Check if already in database
    if (isInDatabase(normalizedMake, normalizedModel)) {
      return { tracked: false, reason: 'already_in_database' };
    }
    
    // Check for spam patterns
    if (isSpamPattern(normalizedMake, normalizedModel)) {
      return { tracked: false, reason: 'spam_pattern' };
    }
    
    // Check if already tracked
    const existingQuery = query(
      collection(db, 'missingPedals'),
      where('make', '==', normalizedMake),
      where('model', '==', normalizedModel)
    );
    
    const existingSnapshot = await getDocs(existingQuery);
    
    if (existingSnapshot.empty) {
      // New entry
      await addDoc(collection(db, 'missingPedals'), {
        make: normalizedMake,
        model: normalizedModel,
        originalMake: make,
        originalModel: model,
        firstReportedBy: userId,
        firstReportedAt: serverTimestamp(),
        usageCount: 1,
        reportedBy: [userId],
        status: 'pending',
        lastReportedAt: serverTimestamp()
      });
      
      return { tracked: true, reason: 'new_entry', usageCount: 1 };
    } else {
      // Existing entry - increment usage count
      const existingDoc = existingSnapshot.docs[0];
      const existingData = existingDoc.data();
      
      // Check if user already reported this
      if (existingData.reportedBy?.includes(userId)) {
        return { tracked: false, reason: 'already_reported_by_user' };
      }
      
      // Update usage count and add user to reportedBy array
      await updateDoc(doc(db, 'missingPedals', existingDoc.id), {
        usageCount: existingData.usageCount + 1,
        reportedBy: [...(existingData.reportedBy || []), userId],
        lastReportedAt: serverTimestamp()
      });
      
      return { 
        tracked: true, 
        reason: 'incremented_usage', 
        usageCount: existingData.usageCount + 1 
      };
    }
  } catch (error) {
    console.error('Error tracking missing pedal:', error);
    return { tracked: false, reason: 'error', error: error.message };
  }
};

export const manuallyAddMissingPedal = async (make, model, userId) => {
  try {
    // Import Firebase functions
    const { db } = await import('../firebase');
    const { collection, addDoc, serverTimestamp } = await import('firebase/firestore');
    
    // Normalize inputs
    const normalizedMake = normalizePedalName(make);
    const normalizedModel = normalizePedalName(model);
    
    // Check if already in database
    if (isInDatabase(normalizedMake, normalizedModel)) {
      return { added: false, reason: 'already_in_database' };
    }
    
    // Check for spam patterns
    if (isSpamPattern(normalizedMake, normalizedModel)) {
      return { added: false, reason: 'spam_pattern' };
    }
    
    // Add to missing pedals collection with manual flag
    await addDoc(collection(db, 'missingPedals'), {
      make: normalizedMake,
      model: normalizedModel,
      originalMake: make,
      originalModel: model,
      firstReportedBy: userId,
      firstReportedAt: serverTimestamp(),
      usageCount: 1,
      reportedBy: [userId],
      status: 'manual_submission',
      lastReportedAt: serverTimestamp(),
      manuallySubmitted: true
    });
    
    return { added: true, reason: 'manual_submission' };
  } catch (error) {
    console.error('Error manually adding missing pedal:', error);
    return { added: false, reason: 'error', error: error.message };
  }
}; 